module.exports = __webpack_public_path__ + "img/inter1_1.3f615f2e.gif";